<section>
  <div class="container-fluid py-4 px-4">

    <div class="container-fluid container-card mb-4">
      <h1 class="heading-1">Sales Activities</h1>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
          <div class="card card-occupancy mb-2 mb-sm-2 mb-lg-0">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/occupancy-lease.png"> Property Activity
              </h5>
              <div class="container-fluid container-box-progress mt-3">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                    <span class="date-property">{{ startDate | dateformat }} - {{ endDate | dateformat }}</span>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <div class="d-flex flex-column align-items-end">
                      <span class="progress-percent-lease">
                        <span class="text-percent-success"> {{ totalEvent.total }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <div class="chart-wrapper">
                  <div class="chart-container">
                    <div id="chart">
                      <div *ngIf="isLoadingTotalEvent" class="text-center p-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading occupancy data...</span>
                        </div>
                      </div>

                      <apx-chart *ngIf="!isLoadingTotalEvent" [series]="chartOptions.series"
                        [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels"
                        [plotOptions]="chartOptions.plotOptions" [yaxis]="chartOptions.yaxis"
                        [xaxis]="chartOptions.xaxis" [legend]="chartOptions.legend" [colors]="chartOptions.colors"
                        [grid]="chartOptions.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="col-12 col-md-12 col-lg-3 my-4 my-lg-0">

          <div class="card card-tenant" [routerLink]="['/sales-activities/sales-list']"
            routerLinkActive="router-link-active">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/tenant.png"> Sales
              </h5>
            </div>
            <div class="card-body card-body-custom">

              <div class="tenant-arrow">
                <img src="assets/icons/arrow-top-right.png" alt="">
              </div>

              <div class="container box-tenant-count h-100">
                <h5 class="text-tenant-count text-center"> {{ ItemSalesTeam.total }} </h5>
              </div>
            </div>
            <div class="card-footer">

              <div class="row mt-2" *ngFor="let item of ItemSalesTeam.members">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <div class="form-group">
                    <h5 class="text-tenant-group"> {{ item.title }} </h5>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <div class="form-group">
                    <h5 class="text-group-count"> {{ item.num_sales }} </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-12 col-md-12 col-lg-5">

          <div class="card card-event">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/event-type.png"> Property State
              </h5>
            </div>
            <div class="card-body card-body-custom">


              <div class="container-box-event my-2" *ngFor="let item of salesPropertyState">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6">
                    <h5 class="title-event">{{ item.name }} </h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <h5 class="total-event">{{ item.total }}</h5>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container-fluid container-card">
      <div class="row g-3">
        <div class="col-12 col-lg-6">
          <h1 class="heading-1">Sales Activities List</h1>
        </div>
        <div class="col-12 col-md-8 col-lg-4">
          <div class="form-group group-input">
            <input type="text" class="form-control" placeholder="Search Sales Activity" [(ngModel)]="searchTerm"
              (keyup)="onSearch($event)" [value]="searchTerm">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-2">
          <div class="custom-dropdown">
            <div class="dropdown">
              <button class="btn btn-outlet-success-custom w-100 d-flex justify-content-between align-items-center"
                data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                {{ selectedStatus || 'All' }}
                <i class="fa-solid fa-chevron-down fa-xs"></i>
              </button>

              <ul class="dropdown-menu show-custom p-4 w-100">
                <li *ngFor="let item of filterStatus; trackBy: trackByStatus">
                  <a class="dropdown-item" [class.active]="selectedStatus === item.name"
                    (click)="onStatusChange(item.name)" style="cursor: pointer;">
                    {{ item.name }}
                    <i *ngIf="selectedStatus === item.name" class="fa-solid fa-check ms-2 text-white">
                    </i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- TAMBAHAN: Button untuk clear all filters (opsional) -->
          <div class="mt-2" *ngIf="selectedStatus !== 'All' || searchTerm">
            <button class="btn btn-outline-secondary btn-sm" (click)="clearAllFilters()" type="button">
              <i class="fa-solid fa-filter-circle-xmark me-1"></i>
              Clear Filters
            </button>
          </div>
        </div>
      </div>

      <div class="table-responsive-lg my-3 p-0 d-none d-lg-block">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="sortable-header" (click)="onSort('property_name')">
                <span>Property Name</span>
                <i [class]="getSortIcon('property_name')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('trans_date')">
                <span>Date</span>
                <i [class]="getSortIcon('trans_date')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('customer')">
                <span>Customer</span>
                <i [class]="getSortIcon('customer')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('property_type')">
                <span>Property Type</span>
                <i [class]="getSortIcon('property_type')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('status')">
                <span>Status</span>
                <i [class]="getSortIcon('status')" class="sort-icon"></i>
              </th>
              <th class="text-end">
                <span>Price Estimate</span>
              </th>
              <!-- <th class="text-center">
                <span>Tax</span>
              </th> -->
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!loading; else loadingTemplate">
              <tr *ngFor="let item of sales">
                <td>
                  <a (click)="OnClickItemSale(item)" routerLinkActive="router-link-active">
                    {{ item.property_name }}
                  </a>
                </td>
                <td class="text-center">{{ item.date|dateformat }}</td>
                <td class="text-center">{{ item.customer }}</td>
                <td class="text-center">{{ item.property_type }}</td>
                <td class="text-center">
                  <span [ngSwitch]="item.status">
                    <span *ngSwitchCase="'Inquiry'" class="badge badge-inquiry">{{ item.status }}</span>
                    <span *ngSwitchCase="'Lost'" class="badge badge-lost">{{ item.status }}</span>
                    <span *ngSwitchCase="'Won'" class="badge badge-won">{{ item.status }}</span>
                    <span *ngSwitchCase="'Hand Over'" class="badge badge-handover">{{ item.status }}</span>
                    <span *ngSwitchDefault>{{ item.status }}</span>
                  </span>
                </td>
                <td class="text-end">{{ item.price_estimate|rupiah }}</td>
                <!-- <td class="text-end">{{ item.tax|rupiah }}</td> -->
              </tr>
              <tr *ngIf="sales.length === 0">
                <td colspan="6" class="text-center">No sales data found</td>
              </tr>
            </ng-container>
            <ng-template #loadingTemplate>
              <tr>
                <td colspan="6" class="text-center">Loading data...</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-sm-block d-md-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button" tabindex="0"
          *ngFor="let item of sales; let i = index"
          [routerLink]="['/sales-activities/sales-activities-detail',item.id]">
          <div class="card-header card-sm-header">
            <h5>{{ item.property_name }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div class="card-sm-title">Status</div>
                <div class="card-sm-title">Date</div>
                <div class="card-sm-title">Property Type</div>
                <div class="card-sm-title">Customer</div>
                <div class="card-sm-title">Price Estimate</div>
              </div>
              <div class="col-7">
                <div class="card-sm-title">
                  <span [ngSwitch]="item.status">
                    <span *ngSwitchCase="'Inquiry'" class="badge badge-inquiry">{{ item.status }}</span>
                    <span *ngSwitchCase="'Won'" class="badge badge-won">{{ item.status }}</span>
                    <span *ngSwitchCase="'Lost'" class="badge badge-lost">{{ item.status }}</span>
                    <span *ngSwitchCase="'Hand Over'" class="badge badge-handover">{{ item.status }}</span>
                    <span *ngSwitchDefault>{{ item.status }}</span>
                  </span>
                </div>
                <div class="card-sm-title">{{ item.date|dateformat }}</div>
                <div class="card-sm-title">{{ item.property_type }}</div>
                <div class="card-sm-title">{{ item.customer }}</div>
                <div class="card-sm-title">{{ item.price_estimate|rupiah }}</div>
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="loading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row mt-4">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start mb-3">
          <div class="pagination-info">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </div>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  </div>
</section>